import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { ProcessSection } from '../components/ProcessSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
export function SalesPage() {
  return <main className="min-h-screen bg-stone-50 font-sans selection:bg-emerald-200 selection:text-emerald-900" data-id="element-119">
      <Hero data-id="element-120" />
      <ProblemSection data-id="element-121" />
      <SolutionSection data-id="element-122" />
      <IncludesSection data-id="element-123" />
      <ProcessSection data-id="element-124" />
      <FAQSection data-id="element-125" />
      <CTASection data-id="element-126" />

      <footer className="bg-stone-900 text-stone-400 py-8 text-center text-sm" data-id="element-127">
        <div className="max-w-7xl mx-auto px-4" data-id="element-128">
          <p data-id="element-129">
            © {new Date().getFullYear()} Protocolo Anti-Inflamación. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs text-stone-500" data-id="element-130">
            Este producto no sustituye el consejo médico profesional. Consulta a
            tu médico antes de comenzar cualquier programa de salud.
          </p>
        </div>
      </footer>
    </main>;
}